const apiMeta = {
  _meta: {
    generateTime: '2026-09-03 09:58:09',
    docUrl: 'https://test-ws.xoyo.com/tools/doc/apis?path=jxsj/groupbuying260902'
  },
  apis: {
    '/jxsj/groupbuying260902/get_config': {
      title: '获得活动、预约、购买和组队状态',
      uri: '/jxsj/groupbuying260902/get_config',
      method: ['GET', 'POST'],
      params: [],
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10402': '请先登录',
        '-10435': '不支持的通行证登录方式',
        '-20104': '账号信息不存在'
      },
      services: ['passport'],
      result: {
        'data{}': {
          account: '脱敏后的当前账号',
          bind_gold: '当前账号可领取的绑金',
          buy_status: '特惠购买时段状态（1：开放，0：关闭）',
          reserve_status: '预约状态（1：已预约，0：未预约）',
          server_name: '新服名称',
          zone: '新服所属区服（实际接口补充字段）',
          team: '当前账号的组队状态',
          total_activate: '展示的预约人数',
          v_exp_time_status: '补买时段状态（1：开放，0：关闭）'
        },
        'data{}.team{}': {
          button_status: '组队按钮状态',
          team_id: '队伍 ID',
          team_status: '队伍状态',
          member_count: '已付款成员数',
          leader_account: '队长账号',
          member_account: '队员账号',
          reserve_status: '当前账号预约状态'
        }
      }
    },
    '/jxsj/groupbuying260902/gift_list': {
      title: '获得九种预购礼包及当前账号购买状态',
      uri: '/jxsj/groupbuying260902/gift_list',
      method: ['GET', 'POST'],
      params: [],
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10402': '请先登录',
        '-10435': '不支持的通行证登录方式',
        '-20104': '账号信息不存在'
      },
      services: ['passport'],
      result: {
        'data{}': {
          gift_list: '礼包列表',
          team: '当前账号的组队状态'
        },
        'data{}.gift_list[]': {
          amount: '展示购买人数',
          gift_id: '礼包编号，1 为双人组队礼包',
          name: '礼包名称',
          price: '特惠价',
          status: '当前账号是否已支付（1：是，0：否）',
          v_exp_price: '补买价'
        }
      }
    },
    '/jxsj/groupbuying260902/get_phone': {
      title: '获得当前账号绑定手机号',
      uri: '/jxsj/groupbuying260902/get_phone',
      method: ['GET', 'POST'],
      params: [],
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10402': '请先登录',
        '-10435': '不支持的通行证登录方式',
        '-20101': '账号没有绑定手机号',
        '-20102': '账号没有绑定身份证'
      },
      services: ['passport'],
      result: {
        'data{}': {
          phone: '绑定手机号'
        }
      }
    },
    '/jxsj/groupbuying260902/get_phone_code': {
      title: '向当前账号绑定手机号发送验证码',
      uri: '/jxsj/groupbuying260902/get_phone_code',
      method: ['GET', 'POST'],
      params: [],
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10101': '手机号码为空',
        '-10102': '手机号码格式错误',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10201': '系统处理中...',
        '-10303': '短信内容为空',
        '-10305': '短信发送手机号码为空',
        '-10306': '短信发送手机号码格式错误',
        '-10308': '短信验证码发送数量达到每日上限',
        '-10309': '短信验证码发送频率太快',
        '-10316': '参数缺失',
        '-10317': '参数类型错误',
        '-10402': '请先登录',
        '-10435': '不支持的通行证登录方式',
        '-10601': '图片验证码为空',
        '-10602': '图片验证码错误',
        '-10603': '极验验证失败',
        '-10604': '图片验证码参数错误',
        '-10605': '图片验证码已过期，请重新刷新',
        '-10606': '顶象验证失败',
        '-12304': '手机号OpenId参数缺失',
        '-20101': '账号没有绑定手机号',
        '-20102': '账号没有绑定身份证'
      },
      services: ['captcha', 'sms', 'passport'],
      result: {
        'data{}': []
      }
    },
    '/jxsj/groupbuying260902/activate': {
      title: '完成身份证和手机验证码校验并预约新服',
      uri: '/jxsj/groupbuying260902/activate',
      method: ['GET', 'POST'],
      params: {
        code: {
          desc: '手机验证码',
          data: ''
        },
        id_num: {
          desc: '当前账号绑定身份证号码',
          data: ''
        }
      },
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10201': '系统处理中...',
        '-10305': '短信发送手机号码为空',
        '-10306': '短信发送手机号码格式错误',
        '-10310': '短信验证码不存在',
        '-10311': '短信验证码为空',
        '-10312': '短信验证码错误',
        '-10313': '短信验证码超过有效期',
        '-10314': '短信验证码已失效',
        '-10315': '短信验证码已经被验证过，请重新获取',
        '-10402': '请先登录',
        '-10435': '不支持的通行证登录方式',
        '-11106': '没有指定游戏',
        '-20101': '账号没有绑定手机号',
        '-20102': '账号没有绑定身份证',
        '-20103': '绑定身份证验证失败，身份证号不一致',
        '-20104': '账号信息不存在',
        '-20105': '该账号已预约',
        '-20106': '该绑定身份证或绑定手机号已预约其他账号'
      },
      services: ['passport', 'game', 'sms'],
      result: {
        'data{}': {
          friends: '已预约的好友角色名，最多三名',
          reserve_status: '预约状态'
        }
      }
    },
    '/jxsj/groupbuying260902/team_config': {
      title: '获得组队客态页或当前账号的组队状态',
      uri: '/jxsj/groupbuying260902/team_config',
      method: ['GET', 'POST'],
      params: {
        team_id: {
          desc: '邀请链接中的队伍 ID，可为空',
          data: ''
        }
      },
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10402': '请先登录',
        '-10435': '不支持的通行证登录方式',
        '-20104': '账号信息不存在',
        '-20118': '队伍 ID 格式错误'
      },
      services: ['passport'],
      result: {
        'data{}': {
          button_status: 'create_team/join_team/invite_friend/team_success/team_full/team_unavailable',
          member_count: '已付款成员数',
          reserve_status: '当前账号预约状态',
          team_id: '队伍 ID'
        }
      }
    },
    '/jxsj/groupbuying260902/create_order': {
      title: '创建礼包支付订单',
      uri: '/jxsj/groupbuying260902/create_order',
      method: ['GET', 'POST'],
      params: {
        gift_id: {
          desc: '礼包编号',
          data: ''
        },
        platform: {
          desc: 'pc/mobile，默认 pc',
          data: ''
        },
        redirect: {
          desc: '支付完成跳转地址，可含 {order_no}',
          data: ''
        },
        team_id: {
          desc: '加入组队礼包时必传邀请队伍 ID；队长创建队伍时留空',
          data: ''
        }
      },
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10201': '系统处理中...',
        '-10402': '请先登录',
        '-10435': '不支持的通行证登录方式',
        '-20107': '不支持的支付平台',
        '-20108': '购买礼包错误',
        '-20109': '您已购买该礼包',
        '-20110': '该订单已支付',
        '-20111': '订单已存在，请稍后重试',
        '-20112': '创建订单失败',
        '-20117': '当前不在礼包购买时间内',
        '-20118': '队伍 ID 格式错误',
        '-20119': '队伍不存在或队长尚未完成购买',
        '-20120': '该队伍已组队成功',
        '-20121': '队长不能加入自己的队伍',
        '-20122': '该队伍已有队友正在支付，请稍后再试',
        '-20124': '组队礼包道具 ID 尚未配置'
      },
      services: ['passport'],
      result: {
        'data{}': {
          order_no: '订单号',
          pay_url: '逍遥支付地址',
          team_id: '组队礼包的队伍 ID',
          team_role: 'leader/member，普通礼包为空'
        }
      }
    },
    '/jxsj/groupbuying260902/callback': {
      title: '逍遥支付回调',
      uri: '/jxsj/groupbuying260902/callback',
      method: ['GET', 'POST'],
      params: [],
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10201': '系统处理中...',
        '-11106': '没有指定游戏',
        '-20104': '账号信息不存在',
        '-20113': '支付回调信息异常',
        '-20114': '签名校验失败',
        '-20115': '订单 ID 错误',
        '-20116': '订单未支付',
        '-20118': '队伍 ID 格式错误',
        '-20123': '队伍状态异常，请刷新页面重试'
      },
      services: ['game'],
      result: {
        'data{}': {
          order_no: '订单号',
          order_status: '支付状态'
        }
      }
    },
    '/jxsj/groupbuying260902/mock_callback': {
      title: '非生产环境模拟支付回调',
      uri: '/jxsj/groupbuying260902/mock_callback',
      method: ['GET', 'POST'],
      params: {
        order_sn: {
          desc: '订单号',
          data: ''
        },
        order_status: {
          desc: '1 成功，0 失败',
          data: ''
        },
        pay_type: {
          desc: '支付类型',
          data: ''
        },
        vouch_code: {
          desc: '外部订单号',
          data: ''
        }
      },
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束',
        '-10201': '系统处理中...',
        '-11106': '没有指定游戏',
        '-20104': '账号信息不存在',
        '-20115': '订单 ID 错误',
        '-20118': '队伍 ID 格式错误',
        '-20123': '队伍状态异常，请刷新页面重试'
      },
      services: ['game'],
      result: {
        'data{}': {
          order_no: '订单号',
          order_status: '支付状态'
        }
      }
    },
    '/jxsj/groupbuying260902/show_account_list': {
      title: '获得所有预约账号角色中财富值前二十名',
      uri: '/jxsj/groupbuying260902/show_account_list',
      method: ['GET', 'POST'],
      params: [],
      errors: {
        '0': '系统错误',
        '1': '成功',
        '-10151': '活动未开启',
        '-10152': '活动配置错误',
        '-10153': '活动未开始',
        '-10154': '活动已结束'
      },
      services: [],
      result: {
        'data{}': {
          data: '角色列表'
        },
        'data{}.data[]': {
          role: '角色名',
          server: '区服名'
        }
      }
    }
  }
};

export default apiMeta;
